import { registerComponent } from "helpers";
import SearchspringComponent from "searchspring";

registerComponent(
  "results-grid",
  class ResultsGrid extends SearchspringComponent {
    siteIDMapping = {
      [WYATT.config.searchspring.siteIds.products]: "products",
      [WYATT.config.searchspring.siteIds.articles]: "articles",
      [WYATT.config.searchspring.siteIds.pages]: "pages",
    };

    constructor() {
      super();

      this.template = this.querySelector('[data-template="item"]');
      this.noResultsTemplate = this.querySelector(
        '[data-template="no-results"]',
      );
      this.gridContentTemplate = this.querySelector(
        '[data-template="grid-content"]',
      );
    }

    get siteId() {
      return this.SearchPage.formData.get("siteId");
    }

    get siteIdKind() {
      return this.siteIDMapping[this.siteId];
    }

    render({ results }) {
      if (this.impressionObserver) {
        this.impressionObserver.disconnect();
        this.impressionObserver = null;
      }

      this.replaceChildren();

      if (!results || results.length === 0) {
        if (this.noResultsTemplate) {
          const noResults = this.noResultsTemplate.content.cloneNode(true);
          this.appendChild(noResults);
        }
        return;
      }

      this.className = `results-grid results-grid--${this.siteIdKind}`;

      const isProducts = this.siteIdKind === "products";

      results.forEach((result) => {
        const item = this.template.content.cloneNode(true).firstElementChild;

        switch (this.siteIdKind) {
          case "products":
            item.innerHTML = `
              <product-summary
                data-handle="${result.handle}"
                data-class-list="product-summary--horizontal product-summary--horizontal-until-medium"
              ></product-summary>
            `;
            break;
          case "articles":
            item.innerHTML = `<article-summary data-handle="${result.brand}/${result.uid}"></article-summary>`;
            break;
          case "pages":
            item.innerHTML = `<a href="${result.url}" class="results-grid__item-link">${result.name}</a>`;
            break;
          default:
            item.innerHTML = `<a href="${result.url}" class="results-grid__item-link">${result.name}</a>`;
            break;
        }

        if (isProducts) {
          item.dataset.ssResult = JSON.stringify({
            uid: result.uid,
            parentId: result.parentId,
            sku: result.sku,
          });
        }

        this.appendChild(item);

        item.addEventListener("click", this.handleClick.bind(this, result));
      });

      if (this.gridContentTemplate) {
        const gridContent = this.gridContentTemplate.content.cloneNode(true);

        document.importNode(gridContent, true);
      }

      if (isProducts && WYATT.beacon) {
        const surface = WYATT.beacon.detectSurface(this);
        if (surface) {
          this.impressionObserver = WYATT.beacon.observeImpressions(
            this,
            surface,
          );
        }
      }
    }

    handleClick(result) {
      const config = WYATT.config.searchspring;

      if (
        config.beaconV2Enabled &&
        this.siteIdKind === "products" &&
        WYATT.beacon
      ) {
        const surface = WYATT.beacon.detectSurface(this);
        if (surface) {
          WYATT.beacon[surface].clickThrough({
            responseId: WYATT.beacon.getResponseId(this),
            results: [WYATT.beacon.normalizeResult(result)],
          });
        }
      }

      if (
        config.legacyTrackingEnabled &&
        typeof IntelliSuggest !== "undefined" &&
        result.intellisuggestData &&
        result.intellisuggestSignature
      ) {
        IntelliSuggest.clickItem(this, {
          siteId: this.siteId,
          intellisuggestData: result.intellisuggestData,
          intellisuggestSignature: result.intellisuggestSignature,
        });
      }
    }
  },
);
